import { useMutation } from '@/services/store';
import { ServiceError, HttpStatus } from '@/services/api';
import { getClientAuthDataByAuthCode } from '../api';
import { IAuthData } from '../context';

interface IClientAuthDataByAuthCodeProps {
  authCode: string;
}

export const useGetClientAuthDataByAuthCode = () => {
  return useMutation<IAuthData, ServiceError, IClientAuthDataByAuthCodeProps>(async ({ authCode }): Promise<IAuthData> => {
    try {
      const clientAuthData = await getClientAuthDataByAuthCode({ body: { authCode } });
      return {
        id: clientAuthData.id,
        token: clientAuthData.token,
        tokenExpired: false,
      };
    } catch (err) {
      if (err instanceof ServiceError && err.status === HttpStatus.UNAUTHORIZED) {
        return {
          id: undefined,
          token: undefined,
          tokenExpired: true,
        };
      }

      throw err;
    }
  });
};
